import * as React from "react";
import type { SVGProps } from "react";
const SvgSmallHourglass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.667 3.72h6.666M4.667 12.61h6.666M5.776 3.723v2.222c0 .35.165.679.445.889l1.778 1.333 1.777-1.333c.28-.21.445-.54.445-.89V3.724"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.22 12.609v-2.223c0-.35-.164-.679-.444-.889L8 8.164 6.22 9.497a1.11 1.11 0 0 0-.445.89v2.221"
    />
  </svg>
);
export default SvgSmallHourglass;
